import { chakra } from '@chakra-ui/system';
import type { HTMLChakraProps } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';
import type { PropsWithChildren } from 'react';

import { useContainerStyles } from './';
import { getClassName } from './className';

export type ContainerFooterProps = PropsWithChildren<unknown> &
  HTMLChakraProps<'div'>;

export const ContainerFooter = ({
  children,
  className,
  ...props
}: ContainerFooterProps) => {
  const styles = useContainerStyles();

  return (
    <chakra.div
      __css={styles.containerFooter}
      className={cx(getClassName('footer'), className)}
      {...props}
    >
      {children}
    </chakra.div>
  );
};
ContainerFooter.displayName = 'ContainerFooter';
